App.SettingsSipController = Em.Controller.extend
  session: Em.inject.service()

  sip_enabled: Em.computed.oneWay 'session.currentBilling.tariff_restrictions.sip_enabled'

  staffWithSip: Em.computed.alias('model')
  showStaffList: Em.computed.and('staffWithSip.length', 'sip_enabled')
